<div class="away-lock-screen">

  <!-- Background blur overlay of the app -->
  <div class="away-lock-backdrop"></div>

  <div class="away-lock-content">

    <ng-container *ngIf="step === 'mpin'">
      <!-- Icon (non-inactivity locks) -->
      <div class="away-lock-icon" [style.background-color]="awayOption?.color" *ngIf="!isInactivityLock">
        <mat-icon>{{ awayOption?.icon }}</mat-icon>
      </div>

      <!-- Locked-user identity: shown in place of the icon for inactivity locks -->
      <div class="away-lock-user-info" *ngIf="isInactivityLock">
        <img class="away-lock-user-avatar" [src]="userProfilePic" alt="Profile" />
        <div class="away-lock-user-meta">
          <p class="away-lock-user-name">{{ userName }}</p>
          <p class="away-lock-user-seat" *ngIf="userMobile">Phone No: {{ userMobile }}</p>
          <p class="away-lock-user-seat" *ngIf="userSeatNo">Seat No: {{ userSeatNo }}</p>
        </div>
      </div>

      <!-- Status label -->
      <p class="away-lock-currently">CURRENTLY</p>
      <h1 class="away-lock-title">{{ awayOption?.label }}</h1>

      <!-- Timer -->
      <div class="away-lock-timer">{{ formattedTime }}</div>
      <p class="away-lock-timer-label">Time away from desk</p>
    </ng-container>

    <!-- Unlock card -->
    <div class="away-lock-card" [class.reason-step]="step === 'reason'" [ngSwitch]="step">

      <!-- ── MPIN entry ─────────────────────────────────── -->
      <ng-container *ngSwitchCase="'mpin'">
        <p class="away-lock-card-hint">
          <mat-icon class="lock-icon">lock</mat-icon>
          Enter your 4-digit MPIN to unlock
        </p>

        <form [formGroup]="form" (keydown.enter)="onUnlock()">
          <div class="code-input-container">
            <div class="boxes-wrapper">
              <input id="digit1" type="text" inputmode="numeric" formControlName="digit1" maxlength="1" class="code-box"
                (input)="onInput($event, 'digit2')" (keydown)="onKeyDown($event, '', 'digit2')" (paste)="onPaste($event)"
                autocomplete="off" autofocus />
              <input id="digit2" type="text" inputmode="numeric" formControlName="digit2" maxlength="1" class="code-box"
                (input)="onInput($event, 'digit3')" (keydown)="onKeyDown($event, 'digit1', 'digit3')" autocomplete="off" />
              <input id="digit3" type="text" inputmode="numeric" formControlName="digit3" maxlength="1" class="code-box"
                (input)="onInput($event, 'digit4')" (keydown)="onKeyDown($event, 'digit2', 'digit4')" autocomplete="off" />
              <input id="digit4" type="text" inputmode="numeric" formControlName="digit4" maxlength="1" class="code-box"
                (input)="onInput($event, '')" (keydown)="onKeyDown($event, 'digit3', '')" autocomplete="off" />
            </div>
            <mat-error *ngIf="lockErrorMessage || (form.invalid && form.touched)" class="error-msg">
              {{ lockErrorMessage || 'MPIN is required' }}
            </mat-error>
          </div>
        </form>

        <button
          class="away-unlock-btn"
          mat-raised-button
          type="button"
          (click)="onUnlock()"
          [disabled]="form.invalid || isUnlocking">
          <span class="btn-content" *ngIf="!isUnlocking">{{ isInactivityLock ? 'Provide Reason & Unlock' : 'Unlock & Resume' }}</span>
          <span class="btn-content" *ngIf="isUnlocking">
            <span class="btn-spinner"></span>
            Unlocking...
          </span>
        </button>

        <p class="away-lock-forgot-mpin">
          <a href="javascript:void(0)" (mousedown)="$event.preventDefault()" (click)="forgotMpin()">Forgot MPIN?</a>
          <span class="away-lock-divider">|</span>
          <a href="javascript:void(0)" (mousedown)="$event.preventDefault()" (click)="logout()">Logout</a>
        </p>
      </ng-container>

      <!-- ── Inactivity reason grid ─────────────────────── -->
      <ng-container *ngSwitchCase="'reason'">
        <p class="away-lock-card-hint">
          <mat-icon class="lock-icon">visibility_off</mat-icon>
          Select a reason for your inactivity to resume
        </p>

        <div class="away-reason-grid">
          <button
            *ngFor="let option of reasonOptions"
            class="away-reason-card"
            type="button"
            [disabled]="isUnlocking"
            (click)="selectReason(option)">
            <span class="away-reason-icon" [style.background-color]="option.color">
              <mat-icon>{{ option.icon }}</mat-icon>
            </span>
            <span class="away-reason-label">{{ option.label }}</span>
          </button>
        </div>

        <p class="away-lock-card-hint reason-loading" *ngIf="isUnlocking">
          <span class="btn-spinner"></span>
          Unlocking...
        </p>
      </ng-container>

      <!-- ── "Other" free-text reason ───────────────────── -->
      <ng-container *ngSwitchCase="'otherReason'">
        <p class="away-lock-card-hint">
          <mat-icon class="lock-icon">edit_note</mat-icon>
          {{ otherReasonPrompt.heading }}
        </p>

        <div class="other-reason-container">
          <textarea
            class="other-reason-textarea"
            rows="3"
            minlength="3"
            maxlength="500"
            [placeholder]="otherReasonPrompt.placeholder"
            [formControl]="otherReasonControl"
            (keydown.enter)="$event.preventDefault(); submitOtherReason()"
            autofocus></textarea>
          <div class="other-reason-footer">
            <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('required')" class="error-msg">
              Please provide a reason
            </mat-error>
            <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('minlength')" class="error-msg">
              Reason must be at least 3 characters
            </mat-error>
            <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('maxlength')" class="error-msg">
              Reason cannot exceed 500 characters
            </mat-error>
            <span class="char-count">{{ otherReasonControl.value.length }}/500</span>
          </div>
        </div>

        <button
          class="away-unlock-btn"
          mat-raised-button
          type="button"
          (click)="submitOtherReason()"
          [disabled]="otherReasonControl.invalid || isUnlocking">
          <span class="btn-content" *ngIf="!isUnlocking">Unlock &amp; Resume</span>
          <span class="btn-content" *ngIf="isUnlocking">
            <span class="btn-spinner"></span>
            Unlocking...
          </span>
        </button>

        <p class="away-lock-forgot-mpin">
          <a href="javascript:void(0)" (mousedown)="$event.preventDefault()" (click)="backToReasonGrid()">&larr; Back to reasons</a>
        </p>
      </ng-container>

      <!-- ── Forgot MPIN: 2FA verification ──────────────── -->
      <ng-container *ngSwitchCase="'twoFactor'">
        <p class="away-lock-card-hint">
          <mat-icon class="lock-icon">verified_user</mat-icon>
          Enter the 6-digit verification code
        </p>

        <div class="code-input-container">
          <div class="boxes-wrapper">
            <input #tf0 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[0]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 0, tf1)" (keydown)="onTwoFactorDigitKeydown($event, 0, null)"
              autocomplete="off" autofocus />
            <input #tf1 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[1]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 1, tf2)" (keydown)="onTwoFactorDigitKeydown($event, 1, tf0)"
              autocomplete="off" />
            <input #tf2 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[2]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 2, tf3)" (keydown)="onTwoFactorDigitKeydown($event, 2, tf1)"
              autocomplete="off" />
            <input #tf3 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[3]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 3, tf4)" (keydown)="onTwoFactorDigitKeydown($event, 3, tf2)"
              autocomplete="off" />
            <input #tf4 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[4]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 4, tf5)" (keydown)="onTwoFactorDigitKeydown($event, 4, tf3)"
              autocomplete="off" />
            <input #tf5 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="twoFactorDigits[5]" (keypress)="allowOnlyNumbers($event)"
              (input)="onTwoFactorDigitInput($event, 5, null)" (keydown)="onTwoFactorDigitKeydown($event, 5, tf4)"
              autocomplete="off" />
          </div>
          <mat-error *ngIf="lockErrorMessage || (twoFactorControl.touched && twoFactorControl.invalid)" class="error-msg">
            {{ lockErrorMessage || 'Enter a valid 6-digit code' }}
          </mat-error>
        </div>

        <button
          class="away-unlock-btn"
          mat-raised-button
          type="button"
          (click)="verifyTwoFactorCode()"
          [disabled]="twoFactorControl.invalid || isUnlocking">
          <span class="btn-content" *ngIf="!isUnlocking">Verify Code</span>
          <span class="btn-content" *ngIf="isUnlocking">
            <span class="btn-spinner"></span>
            Verifying...
          </span>
        </button>

        <p class="away-lock-forgot-mpin">
          <a href="javascript:void(0)" (mousedown)="$event.preventDefault()" (click)="cancelForgotFlow()">&larr; Back to unlock</a>
        </p>
      </ng-container>

      <!-- ── Forgot MPIN: set new MPIN ───────────────────── -->
      <ng-container *ngSwitchCase="'resetMpin'">
        <p class="away-lock-card-hint">
          <mat-icon class="lock-icon">password</mat-icon>
          Set a new 4-digit MPIN
        </p>

        <div class="code-input-container">
          <div class="boxes-wrapper">
            <input #nm0 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="newMpinDigits[0]" (keypress)="allowOnlyNumbers($event)"
              (input)="onNewMpinDigitInput($event, 0, nm1)" (keydown)="onNewMpinDigitKeydown($event, 0, null)"
              autocomplete="off" autofocus />
            <input #nm1 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="newMpinDigits[1]" (keypress)="allowOnlyNumbers($event)"
              (input)="onNewMpinDigitInput($event, 1, nm2)" (keydown)="onNewMpinDigitKeydown($event, 1, nm0)"
              autocomplete="off" />
            <input #nm2 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="newMpinDigits[2]" (keypress)="allowOnlyNumbers($event)"
              (input)="onNewMpinDigitInput($event, 2, nm3)" (keydown)="onNewMpinDigitKeydown($event, 2, nm1)"
              autocomplete="off" />
            <input #nm3 type="text" inputmode="numeric" maxlength="1" class="code-box"
              [value]="newMpinDigits[3]" (keypress)="allowOnlyNumbers($event)"
              (input)="onNewMpinDigitInput($event, 3, null)" (keydown)="onNewMpinDigitKeydown($event, 3, nm2)"
              autocomplete="off" />
          </div>
          <mat-error *ngIf="lockErrorMessage || (newMpinControl.touched && newMpinControl.invalid)" class="error-msg">
            {{ lockErrorMessage || 'MPIN must be exactly 4 digits' }}
          </mat-error>
        </div>

        <button
          class="away-unlock-btn"
          mat-raised-button
          type="button"
          (click)="saveNewMpin()"
          [disabled]="newMpinControl.invalid || isUnlocking">
          <span class="btn-content" *ngIf="!isUnlocking">Reset MPIN</span>
          <span class="btn-content" *ngIf="isUnlocking">
            <span class="btn-spinner"></span>
            Saving...
          </span>
        </button>

        <p class="away-lock-forgot-mpin">
          <a href="javascript:void(0)" (mousedown)="$event.preventDefault()" (click)="cancelForgotFlow()">&larr; Back to unlock</a>
        </p>
      </ng-container>
    </div>

  </div>

</div>
